(() => {
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (designMode || reduce || !('IntersectionObserver' in window)) return;

  const TARGETS = [
    '.section-head',
    '.product-grid > *',
    '.categories > .category',
    '.silhouettes',
    '.benefits > .benefits__item',
    '.editorial-image',
    '.editorial-copy',
    '.chikas-statement__inner > *',
    '.chikas-stories__lead',
    '.chikas-stories',
    '.chikas-ig__head',
    '.chikas-ig__embed',
    '.chikas-ig__hint',
    '.chikas-footer__brand',
    '.chikas-footer__col',
    '.chikas-footer__bottom',
  ].join(',');

  const SKIP = [
    '.chikas-hero',
    '#MainContent > .shopify-section:first-child',
    '[data-universo-section]',
    '[data-u-reveal]',
    '.sobre-intro',
    '.product-page',
    '.cart-page',
    '.chikas-drawer',
  ].join(',');

  const STEP_MS = 80;
  const MAX_STEPS = 6;
  const DURATION_MS = 900;

  document.documentElement.classList.add('cr-on');

  const SHOW_RATIO = 0.12;
  const timers = new WeakMap();

  const clearTimer = (el) => {
    const t = timers.get(el);
    if (t) window.clearTimeout(t);
    timers.delete(el);
  };

  const show = (el, delay) => {
    clearTimer(el);
    el.classList.remove('cr-up');
    el.style.setProperty('--cr-delay', `${delay}ms`);
    el.classList.add('cr-in');
    timers.set(
      el,
      window.setTimeout(() => {
        el.classList.add('cr-done');
        timers.delete(el);
      }, delay + DURATION_MS)
    );
  };

  const hide = (el, exitedAbove) => {
    clearTimer(el);
    el.classList.remove('cr-in', 'cr-done');
    el.classList.toggle('cr-up', exitedAbove);
  };

  const io = new IntersectionObserver(
    (entries) => {
      const entering = [];
      entries.forEach((entry) => {
        const el = entry.target;
        const isIn = el.classList.contains('cr-in');
        if (!entry.isIntersecting) {
          if (isIn) {
            const rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
            hide(el, entry.boundingClientRect.bottom <= rootTop);
          }
          return;
        }
        if (!isIn && entry.intersectionRatio >= SHOW_RATIO) entering.push(entry);
      });
      entering
        .sort(
          (a, b) =>
            a.boundingClientRect.top - b.boundingClientRect.top ||
            a.boundingClientRect.left - b.boundingClientRect.left
        )
        .forEach((entry, i) => show(entry.target, Math.min(i, MAX_STEPS) * STEP_MS));
    },
    { threshold: [0, SHOW_RATIO] }
  );

  const scan = () => {
    const viewH = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll(TARGETS).forEach((el) => {
      if (el.hasAttribute('data-cr')) return;
      el.setAttribute('data-cr', '');
      if (el.closest(SKIP)) return;
      const rect = el.getBoundingClientRect();
      const onScreen = rect.height > 0 && rect.top < viewH * 0.92 && rect.bottom > 0;
      el.classList.add('cr');
      if (onScreen) el.classList.add('cr-in', 'cr-done');
      io.observe(el);
    });
  };

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const mo = new MutationObserver((records) => {
    if (records.some((r) => r.addedNodes.length)) queueScan();
  });
  const watch = () => {
    const main = document.getElementById('MainContent');
    if (main) mo.observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
